// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".see-articles[data-v-109d0cc8]{color:var(--brand-textButtonClear)}.see-articles svg[data-v-109d0cc8]{color:var(--brand-textButtonClear)}", "",{"version":3,"sources":["/app/app/javascript/widget/components/ArticleCategoryCard.vue"],"names":[],"mappings":"AACA,+BACE,kCAAA,CACA,mCACE,kCAAA","file":"ArticleCategoryCard.vue","sourcesContent":["\n.see-articles {\n  color: var(--brand-textButtonClear);\n  svg {\n    color: var(--brand-textButtonClear);\n  }\n}\n"]}]);
// Exports
module.exports = exports;
